import * as api from 'api/offer/offerFinancingStructureApi';
import * as actionTypes from 'actions/actionTypes/offer/financials/offerFinancingStructure';
import * as eventTypes from 'actions/eventTypes/offer/financials/offerFinancingStructure';
import { sendHttpRequest, sendHttpCommandAndWaitForEvent } from 'actions/actionCreators/httpActions';
import { showError } from 'actions/actionCreators/snackbarActions';

export function loadOfferFinancingStructure(documentId, siteId) {
  return async (dispatch, getState) => {
    const financingStructureData = getState().currentOffer.financingStructureData;
    if (financingStructureData.financingStructureLoaded) {
      return;
    }

    try {
      const financingStructure = await dispatch(sendHttpRequest(api.getFinancingStructure(documentId, siteId)));
      dispatch({ type: actionTypes.LOAD_OFFER_FINANCING_STRUCTURE_SUCCEEDED, payload: financingStructure });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function saveOfferFinancingStructure(documentId, siteId, financingStructure) {
  return dispatch => {
    dispatch({
      type: actionTypes.SAVE_OFFER_FINANCING_STRUCTURE_STARTED,
      payload: { documentId, siteId, financingStructure }
    });
    dispatch(
      sendHttpCommandAndWaitForEvent(
        api.updateFinancingStructure(documentId, siteId, financingStructure),
        'UpdateOfferFinancingStructure',
        [eventTypes.OFFER_FINANCING_STRUCTURE_UPDATED]
      )
    )
      .then(event => {
        if (event.ok) {
          dispatch({
            type: actionTypes.SAVE_OFFER_FINANCING_STRUCTURE_SUCCEEDED,
            payload: { documentId, siteId, financingStructure }
          });
        } else {
          dispatch({
            type: actionTypes.SAVE_OFFER_FINANCING_STRUCTURE_FAILED,
            payload: { documentId, siteId, financingStructure, error: event }
          });
        }
      })
      .catch(error => {
        dispatch({
          type: actionTypes.SAVE_OFFER_FINANCING_STRUCTURE_FAILED,
          payload: { documentId, siteId, financingStructure, error }
        });
        dispatch(showError(error.message, error.correlationId));
      });
  };
}

export const setFinancialProductIdOnSimulation = (documentId, siteId, financialProductId, callbackFn = () => {}) => {
  return dispatch => {
    dispatch(
      sendHttpCommandAndWaitForEvent(
        api.setFinancialProductIdOnSimulation(documentId, siteId, financialProductId),
        'setFinancialProductIdOnSimulationCommand',
        [eventTypes.FINANCIAL_PRODUCT_ID_ON_SIMULATION_UPDATED],
        false
      )
    )
      .then(event => {
        if (event.ok) {
          callbackFn();
        } else {
          callbackFn(true);
          dispatch({
            type: actionTypes.FINANCIAL_PRODUCT_ID_SET_FAILED
          });
        }
      })
      .catch(err => {
        callbackFn(true);
        dispatch({
          type: actionTypes.FINANCIAL_PRODUCT_ID_SET_FAILED
        });
        dispatch(showError(err.message));
      });
  };
};

export const getAvailableFinancialProducts = (documentId, siteId, contractTypeId, callbackFn = () => {}) => {
  return dispatch => {
    dispatch(
      sendHttpCommandAndWaitForEvent(
        api.getAvailableFinancialProducts(documentId, siteId, contractTypeId),
        'getAvailableFinancialProductsCommand',
        [eventTypes.AVAILABLE_FINANCIAL_PRODUCTS_RETRIEVED],
        false
      )
    )
      .then(event => {
        if (event.ok) {
          callbackFn(event.eventBody.availableFinancialProducts, false);
          dispatch({
            type: actionTypes.AVAILABLE_FINANCIAL_PRODUCTS_RETRIEVAL_SUCCEEDED
          });
        } else {
          callbackFn([], true);
          dispatch({
            type: actionTypes.AVAILABLE_FINANCIAL_PRODUCTS_RETRIEVAL_FAILED
          });
        }
      })
      .catch(err => {
        dispatch({
          type: actionTypes.AVAILABLE_FINANCIAL_PRODUCTS_RETRIEVAL_FAILED
        });
        dispatch(showError(err.message));
      });
  };
};

export function computeMaxResidualValuePercent(documentId, siteId, financingStructure) {
  return dispatch => {
    dispatch({
      type: actionTypes.COMPUTE_OFFER_FINANCING_STRUCTURE_MAX_RESIDUAL_VALUE_STARTED,
      payload: { documentId, siteId, financingStructure }
    });

    dispatch(
      sendHttpCommandAndWaitForEvent(
        api.computeOfferMaxResidualValuePercent(documentId, siteId, financingStructure),
        'computeOfferResidualValueCommand',
        [eventTypes.OFFER_MAX_RESIDUAL_VALUE_COMPUTED],
        false
      )
    )
      .then(event => {
        if (event.ok) {
          dispatch({
            type: actionTypes.COMPUTE_OFFER_FINANCING_STRUCTURE_MAX_RESIDUAL_VALUE_SUCCEEDED,
            payload: { documentId, siteId, maxResidualValuePercent: event.eventBody.maxResidualValuePercent }
          });
        } else {
          dispatch({
            type: actionTypes.COMPUTE_OFFER_FINANCING_STRUCTURE_MAX_RESIDUAL_VALUE_FAILED,
            payload: { documentId, siteId, financingStructure, event }
          });
        }
      })
      .catch(error => {
        dispatch({
          type: actionTypes.COMPUTE_OFFER_FINANCING_STRUCTURE_MAX_RESIDUAL_VALUE_FAILED,
          payload: { documentId, siteId, financingStructure, error }
        });
        dispatch(showError(error.message, error.correlationId));
      });
  };
}

export function cancelFinancingStructureChanges(documentId, siteId) {
  return { type: actionTypes.CANCEL_OFFER_FINANCING_STRUCTURE_CHANGES, payload: { documentId, siteId } };
}

export function saveOfferNegotiationAmount(documentId, siteId, amounts) {
  return async dispatch => {
    try {
      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(
          api.negotiateAmount(documentId, siteId, amounts),
          'NegotiateOfferAmount',
          [eventTypes.OFFER_NEGOTIATE_AMOUNT_COMPUTED],
          false
        )
      );
      return event;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}
